import { useState } from 'react'
import './SearchSector.css'

const SearchSector = ({ setSelectedSector, selectedSector, sectors, handleSearch, label }) => {

  const [search, setSearch] = useState('');

  const onChange = (newValue) => {
    setSearch(newValue)
    handleSearch(newValue)
  }

  const clearSelection = () => {
    setSelectedSector({});
    setSearch('');
  };

  const select = (name) => {
    setSelectedSector(name);
    setSearch('')
  }

  return (
    <div className='search_sector_container'>
      {(!selectedSector?.id) ? (
        <input
          type="text"
          placeholder={label || 'Choisissez un pays'}
          className='input_selectedSector'
          onChange={(e) => onChange(e.target.value)}
        />

      ) : (
        <div className={"search_sector_selected search_sector_relative"}>
          <span onClick={() => select(selectedSector)}>
            <div className='search_sector_item_select'>
              {selectedSector?.image && <img className='search_sector_picture' src={`https://cdn.goliaths.io/categories/${selectedSector.image}`} alt=''/>}
              {selectedSector.name}
            </div>
          </span>
          <div onClick={clearSelection} className='delete_item_select'>x</div>
        </div>
      )}
      {(!selectedSector?.id) && sectors.length > 0 && search.length > 0 && (
        <ul className='search_sector_list_box'>
          {sectors.map((sector, index) => (
            <li key={index} onClick={() => select(sector)} className="search_sector_not_selected">
              <div className='search_sector_item_select'>
                {sector?.image && <img className='search_sector_picture' src={`https://cdn.goliaths.io/categories/${sector.image}`} alt=''/>}
                {sector.name}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchSector